import DomainResource from './DomainResource';
import merge from 'lodash/merge';

export default class BN_TreatmentPlanLibraryObjective extends DomainResource {
    static _className = 'BN_TreatmentPlanLibraryObjective';

    _objectStructure = {
        categoryId: String,
        modal: String,
        text: String,
        intervention: [String],
    };

    constructor(constructJson, className = 'BN_TreatmentPlanLibraryObjective') {
        super(constructJson, className);
        this.createAndPopulateStructure(this._objectStructure, constructJson, this._objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this._objectStructure));
    }
}
